import ApiService from './apiService';

/**
 * Service pour gérer les paramètres de l'entreprise
 */
class CompanySettingService {
    /**
     * Récupérer les paramètres de l'entreprise
     * @returns {Promise} Réponse de l'API avec les paramètres de l'entreprise
     */
    getCompanySettings() {
        return ApiService.get('/company-settings');
    }

    /**
     * Mettre à jour les paramètres de l'entreprise
     * @param {Object} settingsData Données des paramètres à mettre à jour
     * @param {Boolean} [settingsData.allow_zero_quantity_sales] Autoriser les ventes avec quantité zéro
     * @param {Boolean} [settingsData.update_product_price_on_sale] Mettre à jour le prix du produit lors d'une vente
     * @param {Number|null} [settingsData.max_cash_registers] Nombre maximum de caisses (null = infini)
     * @returns {Promise} Réponse de l'API avec les paramètres mis à jour
     */
    updateCompanySettings(settingsData) {
        return ApiService.put('/company-settings', settingsData);
    }

    /**
     * Réinitialiser les paramètres aux valeurs par défaut
     * @returns {Promise} Réponse de l'API avec les paramètres réinitialisés
     */
    resetCompanySettings() {
        return ApiService.post('/company-settings/reset');
    }
}

export default new CompanySettingService();
